import { DialogTitle } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { PriceControlAction } from '@retail/price-control/types';
import { Dialog } from '@shared/components';
import { SentryErrorBoundary } from '@retail/components';
import { HandleItemsEventAction } from './HandleItemsEvenAction';

interface Props {
  open: boolean;
  itemIdsToHandle: number[];
  includeVat: boolean;
  handleItemEventAction: (action: PriceControlAction) => void;
  onClose: () => void;
}

export default function HandleItemsEventActionDialog({
  open,
  itemIdsToHandle,
  includeVat,
  handleItemEventAction,
  onClose,
}: Props) {
  const t = useMyAssortmentTFunction();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      sx={{ '& .MuiPaper-root': { height: '100%' } }}
    >
      <DialogTitle>{t('myAssortment.actions.handleItems')}</DialogTitle>
      <SentryErrorBoundary>
        <HandleItemsEventAction
          itemIdsToHandle={itemIdsToHandle}
          includeVat={includeVat}
          handleItemEventAction={handleItemEventAction}
          onClose={onClose}
        />
      </SentryErrorBoundary>
    </Dialog>
  );
}
